import { FormControl, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { CurrencyFieldConfiguration } from '../../../api/ConfigApi';
import { getCurrencySymbol } from '../../../util/util';
import FieldLabel from '../../fields/FieldLabel';

type FieldProps = Omit<CurrencyFieldConfiguration, 'name'>;
interface Props<T> extends FieldProps, UseControllerProps<T> {
	save?: (currValue: string, fieldName: string) => void;
}

const CurrencyField = <T extends FieldValues>(props: Props<T>) => {
	const {
		control,
		name,
		title,
		optional,
		multiline,
		currency,
		disabled,
		helperText,
		save,
	} = props;
	const currencyVal = getCurrencySymbol(currency || 'USD');

	return (
		<Controller
			control={control}
			name={name}
			render={({ field, fieldState: { error } }) => (
				<FormControl error={!!error} sx={{ width: '100%' }}>
					<FieldLabel title={title} required={!optional} htmlFor={name} />
					<TextField
						{...field}
						fullWidth
						id={name}
						multiline={multiline}
						maxRows={4}
						required={!optional}
						error={!!error}
						InputProps={{
							startAdornment: (
								<InputAdornment position='start'>{currencyVal}</InputAdornment>
							),
						}}
						helperText={
							error?.message ? error.message : helperText ? helperText : null
						}
						disabled={disabled}
						onChange={(e) => {
							// prevent input of space characters anywhere in the field
							const trimmedValue = e.target.value.replace(/\s+/g, '');
							field.onChange(trimmedValue);
						}}
						onBlur={(e) => {
							field.onBlur();
							save && save(e.target.value, name);
						}}
					/>
				</FormControl>
			)}
		/>
	);
};

export default CurrencyField;
